export * from "@trpc/react-query/shared";

export const ENDPOINTS = [
  "admin",
  "apiKeys",
  "appRoutingForms",
  "apps",
  "auth",
  "availability",
  "appBasecamp3",
  "bookings",
  "calendars",
  "calVideo",
  "credentials",
  "deploymentSetup",
  "dsync",
  "eventTypes",
  "features",
  "highPerf",
  "i18n",
  "insights",
  "me",
  "ooo",
  "payments",
  "public",
  "timezones",
  "saml",
  "slots",
  "teams",
  "organizations",
  "travelSchedules",
  "users",
  "viewer",
  "webhook",
  "workflows",
  "googleWorkspace",
  "oAuth",
  "attributes",
  "delegationCredential",
  "routingForms",
  "credits",
  "filterSegments",
] as const;
